import React from 'react';
import { Data } from '../../types';
import * as SiteManager from '../domain/site-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { useData, dataFromDataset } from './DataProviderCache';

type ContextState = Data<
    Array<{
        siteId: string;
        siteName: string;
        alarmCount: number;
        deviceCount: number;
    }>
>;
const Context = React.createContext<ContextState | null>(null);
function useSiteAlarmListData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useSiteAlarmListData must be used within a SiteAlarmListProvider');
    }
    return contextState;
}
const SiteAlarmListProvider: React.FC<{ locationId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'site-alarm-list-data',
        id: props.locationId,
        dataFn: React.useCallback(() => SiteManager.getSitesWithAlarmData(authHelper, props.locationId), [
            authHelper,
            props.locationId
        ]),
    });

    const siteAlarmData = dataFromDataset(dataset);

    return <Context.Provider value={siteAlarmData}>{props.children}</Context.Provider>;
};

export { SiteAlarmListProvider, useSiteAlarmListData };
